module.exports = __webpack_public_path__ + "media/product/p-9-3db9bbab.png";